import { cjk } from "@streamdown/cjk";
import { code } from "@streamdown/code";
import { math } from "@streamdown/math";
import { mermaid } from "@streamdown/mermaid";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import remarkGemoji from "remark-gemoji";
import {
  defaultRemarkPlugins,
  type PluginConfig,
  type StreamdownTranslations,
} from "streamdown";

export const CHAT_PLUGINS: PluginConfig = { cjk, code, math, mermaid };

export const CHAT_REMARK_PLUGINS = [
  ...Object.values(defaultRemarkPlugins),
  remarkGemoji,
];

const CHAT_TRANSLATION_KEYS = [
  "copied",
  "copyCode",
  "copyLink",
  "copyTable",
  "copyTableAsCsv",
  "copyTableAsMarkdown",
  "copyTableAsTsv",
  "downloadDiagram",
  "downloadDiagramAsMmd",
  "downloadDiagramAsPng",
  "downloadDiagramAsSvg",
  "downloadFile",
  "downloadImage",
  "downloadTable",
  "downloadTableAsCsv",
  "downloadTableAsMarkdown",
  "close",
  "exitFullscreen",
  "viewFullscreen",
  "externalLinkWarning",
  "imageNotAvailable",
  "openExternalLink",
  "openLink",
  "resetView",
  "zoomIn",
  "zoomOut",
  "mermaidFormatMmd",
] as const;

export function useChatTranslations(): Partial<StreamdownTranslations> {
  const t = useTranslations("site.chat.markdown");

  return useMemo(
    () => ({
      ...Object.fromEntries(CHAT_TRANSLATION_KEYS.map((key) => [key, t(key)])),
      mermaidFormatPng: "PNG",
      mermaidFormatSvg: "SVG",
      tableFormatCsv: "CSV",
      tableFormatMarkdown: "Markdown",
      tableFormatTsv: "TSV",
    }),
    [t],
  );
}
